




















































































import { Component, Vue, Watch } from 'vue-property-decorator';
import { mapState } from 'vuex';
import _ from 'lodash';
import ProductBrandsModal from '../modals/ProductBrandsModal.vue';
import { Spinner } from 'vue-image-spinner2';

@Component({
    name: 'product-brands',
    data: function () {
        return {
            ordersPage_: 1,
        };
    },
    components: {
        ProductBrandsModal,
        Spinner,
    },
    computed: {
        ...mapState('productBrands', ['allProductBrands', 'nestedProductBrands', 'allProductBrandsLoading']),
    },
})
export default class ProductBrands extends Vue {
    public allProductBrands!: any;
    public nestedProductBrands!: any;
    public allProductBrandsLoading!: any;
    public brand_search: any = '';
    public ordersPerPage!: any;
    public ordersPage!: any;
    private activeOrderLoaded: boolean = false;
    private activeFilters: boolean = false;
    private view = 'tree';

    allProductBrandsHeaders = [
        { thClass: 'th', key: 'id', label: 'ID' },
        { thClass: 'th', key: 'name', label: 'Nombre' },
        { thClass: 'th', key: 'edit', label: '' },
        { thClass: 'th', key: 'delete', label: '' },
    ];

    get allProductBrandsCollection() {
        return this.allProductBrands.filter((cat) => {
            return (
                cat.name.includes(this.brand_search) ||
                cat.name.toLowerCase().includes(this.brand_search) ||
                cat.name.toUpperCase().includes(this.brand_search)
            );
        });
    }

    setUrlSort(ctx: any) {
        this.$router.push({
            path: 'product-brands',
            query: {
                ...this.$route.query,
                sortName: ctx.sortBy,
                sortValue: ctx.sortDesc ? 'desc' : 'asc',
            },
        });
    }

    clearFilters() {
        this.$router.push({
            path: 'orders',
            query: {},
        });
    }

    onEditOrder(id: number) {
        this.$store.dispatch('orders/getOne', { id });
        this.activeOrderLoaded = true;
        setTimeout(() => {
            this.$bvModal.show('order-detail-modal');
        }, 400);
    }

    @Watch('$route')
    getAllProductBrands() {
        if (this.$route.query.search) {
            this.$store.dispatch('productBrands/getAll', {
                search: <string>this.$route.query.search,
            });
        } else {
            this.$store.dispatch('productBrands/getAll');
        }
    }

    onOpenProductBrandModal(id: string | null = null) {
        this.$store.dispatch('productBrands/getOne', id);
        setTimeout(() => {
            this.$bvModal.show('product-brands-modal');
        }, 400);
    }

    onDeleteProductBrandModal(id: string) {
        this.$store.dispatch('productBrands/deleteOne', { id, vm: this });
        setTimeout(() => {
            this.$store.dispatch('productBrands/getAll');
        });
    }

    onDel(node) {
        // console.log(node.id);
        this.onOpenProductBrandModal(node.id);
        // node.remove();
    }

    mounted() {
        this.getAllProductBrands();
        this.ordersPage = 1;
    }
}
